// ConfettiCustom - Physics System
import { ConfettiPiece, PhysicsConfig } from './types';
import { VELOCITY_RANGE, ROTATION_SPEED_RANGE } from './constants';

export class ConfettiPhysics {
  private config: PhysicsConfig;

  constructor(config: PhysicsConfig) {
    this.config = config;
  }

  /**
   * Atualiza a física de uma partícula de confete
   */
  updatePiece(piece: ConfettiPiece, deltaTime: number = 1): void {
    // Aplicar gravidade
    piece.vy += this.config.gravity * deltaTime;
    
    // Aplicar vento
    piece.vx += this.config.wind * deltaTime;
    
    // Aplicar resistência do ar
    piece.vx *= this.config.friction;
    piece.vy *= this.config.friction;
    
    // Atualizar posição
    piece.x += piece.vx * deltaTime;
    piece.y += piece.vy * deltaTime;
    
    // Atualizar rotação
    piece.rotation += piece.rotationSpeed * deltaTime;
    
    // Normalizar rotação
    if (piece.rotation > 360) {
      piece.rotation -= 360;
    } else if (piece.rotation < 0) {
      piece.rotation += 360;
    }
    
    // Reduzir vida da partícula
    piece.life -= deltaTime * 0.001; // Reduz 0.1% por frame a 60fps
  }

  /**
   * Verifica se uma partícula está fora dos limites
   */
  isOutOfBounds(piece: ConfettiPiece, width: number, height: number): boolean {
    return (
      piece.x < -50 || 
      piece.x > width + 50 || 
      piece.y > height + 50 ||
      piece.life <= 0
    );
  }

  /**
   * Gera uma nova partícula de confete
   */
  generatePiece(width: number, height: number, colors: string[]): ConfettiPiece {
    const shapes: Array<'square' | 'circle' | 'rectangle' | 'triangle'> = [
      'square', 'circle', 'rectangle', 'triangle'
    ];
    
    return {
      x: Math.random() * width,
      y: -Math.random() * 100, // Começa acima da tela
      vx: VELOCITY_RANGE.x.min + Math.random() * (VELOCITY_RANGE.x.max - VELOCITY_RANGE.x.min),
      vy: VELOCITY_RANGE.y.min + Math.random() * (VELOCITY_RANGE.y.max - VELOCITY_RANGE.y.min),
      rotation: Math.random() * 360,
      rotationSpeed: ROTATION_SPEED_RANGE.min + Math.random() * (ROTATION_SPEED_RANGE.max - ROTATION_SPEED_RANGE.min),
      color: colors[Math.floor(Math.random() * colors.length)],
      shape: shapes[Math.floor(Math.random() * shapes.length)],
      size: 4 + Math.random() * 8, // Entre 4 e 12
      life: 1.0
    };
  }
}
